// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.feature-grid[data-v-0cfcfc8e] {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 40px 30px;
  justify-items: center;
}
.feature-card[data-v-0cfcfc8e] {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 75px;
  border: 1px solid #0a536e;
  border-radius: 5px;
  background: #fff;
  color: #175874;
  cursor: pointer;
  transition: all .15s ease;
  padding: 12px 16px;
  text-align: left;
}
.feature-card.active[data-v-0cfcfc8e] {
  background: #0a536e;
  border-color: #0a536e;
  color: #fff;
}
.feature-inner[data-v-0cfcfc8e] {
  display: flex;
  align-items: center;
  gap: 12px;
}
.feature-label[data-v-0cfcfc8e] {
  overflow: hidden;
  text-overflow: ellipsis;
}
.feature-tooltip[data-v-0cfcfc8e] {
  position: absolute;
  top: -8px;
  left: 0;
  width: 100%;
  transform: translateY(-100%);
  opacity: 0;
  transition: all .16s ease;
  pointer-events: none;
  background: #fff;
  color: #5F6B71;
  border-radius: 5px;
  padding: 10px 15px;
  box-shadow: 0 -1px 3px -1px rgba(0,0,0,.28), 0 6px 18px rgba(0,0,0,.18);
  z-index: 1;
}
.feature-card:hover .feature-tooltip[data-v-0cfcfc8e] {
  opacity: 1;
  transform: translateY(-100%) scale(1);
}
.feature-tooltip[data-v-0cfcfc8e]::after {
  /* hide default tooltip */
  background: none;
}
.tooltip-body[data-v-0cfcfc8e] {
  font-size: 12px;
}
.tooltip-arrow[data-v-0cfcfc8e] {
  position: absolute;
  bottom: -13px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  width: 26px;
  height: 26px;
  background: #fff;
  z-index: -1;
}
.feature-card.active .tooltip-title[data-v-0cfcfc8e] {
  color: #0a536e;
}
.feature-icon[data-v-0cfcfc8e] {
  width: 30px;
  height: 30px;
  fill: currentColor;
}
.feature-icon-time[data-v-0cfcfc8e] {
  width: 40px;
  height: 40px;
}
.feature-icon-auto[data-v-0cfcfc8e] {
  width: 37px;
  height: 37px;
}
.feature-icon-chat[data-v-0cfcfc8e] {
  width: 36px;
  height: 36px;
}
.feature-divider[data-v-0cfcfc8e] {
  border-top: .05rem solid #dadee4;
  margin: 0.2rem 0 0.4rem 0;
}
.registration-data-subtitle[data-v-0cfcfc8e] {
  margin-top: 55px;
  font-size: 1rem;
}
@media (max-width: 450px) {
  /* First card: show tooltip below instead of above */
.feature-card:first-child .feature-tooltip[data-v-0cfcfc8e] {
    top: auto;
    bottom: -8px;
    transform: translateY(100%);
}
.feature-card:first-child .tooltip-arrow[data-v-0cfcfc8e] {
    top: -13px;
    bottom: auto;
}
.feature-card[data-v-0cfcfc8e] {
    width: 250px;
}
.registration-data-subtitle[data-v-0cfcfc8e] {
    margin-top: 18px;
    font-size: 16px;
}
}
@media (max-width: 617px) {
.feature-grid[data-v-0cfcfc8e] {
    gap: 15px 30px;
}
}
`, "",{"version":3,"sources":["webpack://./src/view/components/registration/components/RegistrationData.vue"],"names":[],"mappings":";AAoGA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAc;EACd,qBAAqB;AACvB;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,4BAA4B;EAC5B,UAAU;EACV,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,uEAAuE;EACvE,UAAU;AACZ;AAEA;EACE,UAAU;EACV,qCAAqC;AACvC;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AAEA;EACE,eAAe;AACjB;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,yCAAyC;EACzC,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;AAEA;EACE,cAAc;AAChB;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AAEA;EACE,WAAW;EACX,YAAY;AACd;AAEA;EACE,WAAW;EACX,YAAY;AACd;AAEA;EACE,WAAW;EACX,YAAY;AACd;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;AAEA;EACE,oDAAoD;AACpD;IACE,SAAS;IACT,YAAY;IACZ,2BAA2B;AAC7B;AAEA;IACE,UAAU;IACV,YAAY;AACd;AAEA;IACE,YAAY;AACd;AAEA;IACE,gBAAgB;IAChB,eAAe;AACjB;AACF;AAEA;AACE;IACE,cAAc;AAChB;AACF","sourcesContent":["<script setup lang=\"ts\">\nimport { computed, inject, Ref } from 'vue';\nimport PtoIcon from '../../../assets/icons/PtoIcon.vue';\nimport AutoIcon from '../../../assets/icons/AutoIcon.vue';\nimport OplusChatIcon from '../../../assets/icons/OplusChatIcon.vue';\nimport OplusLogoIcon from '../../../assets/icons/OplusLogoIcon.vue';\nimport TimecardAppIcon from '../../../assets/icons/TimecardAppIcon.vue';\nimport { Feature } from '../model/registration';\nimport { FeatureCode, RegistrationViewModel, UserRegistrationViewModel } from '../model/registration';\nimport { RegistrationPresenter } from '../../../../presenter/registration';\nimport { groupRegistrationPresenterInjectKey, registrationViewModelInjectKey, userRegistrationViewModelInjectKey } from '../../../../provider/provider';\n\n\nconst viewModel: Ref<RegistrationViewModel> | undefined = inject(registrationViewModelInjectKey);\nconst userViewModel: Ref<UserRegistrationViewModel> | undefined = inject(userRegistrationViewModelInjectKey);\nconst presenter: RegistrationPresenter | undefined = inject(groupRegistrationPresenterInjectKey);\n\nconst features: Feature[] = [\n  {\n    id: FeatureCode.PRO,\n    label: 'シフト管理',\n    tooltip: 'スマホで提出したシフトは管理画面に自動反映。希望シフト回収、作成、スタッフへの共有までカンタン操作！',\n    icon: OplusLogoIcon,\n  },\n  {\n    id: FeatureCode.TIME,\n    label: '勤怠管理',\n    tooltip: 'WEB打刻やQRコード打刻など、業種や業態に合わせた打刻方法を提供。シフトと勤怠の一元管理を実現。',\n    icon: TimecardAppIcon,\n    iconClass: 'feature-icon-time',\n  },\n  {\n    id: FeatureCode.PTO,\n    label: '有休管理',\n    tooltip: '有休申請から承認までシンプルに行なえ、スタッフごとの取得状況も手軽に管理。',\n    icon: PtoIcon,\n  },\n  {\n    id: FeatureCode.AUTO,\n    label: '自動シフト作成',\n    tooltip: '条件を設定して自動作成ボタンをワンクリックするだけでシフト作成！貴社にあったロジック設定や段階的割当も可能。',\n    icon: AutoIcon,\n    iconClass: 'feature-icon-auto',\n  },\n  {\n    id: FeatureCode.CHAT,\n    label: 'oplus chat',\n    tooltip: '業務連絡も日々のコミュニケーションも一元化。個人SNSに頼らず、スムーズな情報共有とチーム連携を実現。',\n    icon: OplusChatIcon,\n    iconClass: 'feature-icon-chat',\n  },\n];\n\nconst selectedFeatures = computed((): number[] => {\n  return viewModel?.value.selectedFeatures || [];\n})\n\nfunction toggleSelected(id: number) {\n  // PRO (shift) can't be unselected\n  if (id === FeatureCode.PRO) {\n    return;\n  }\n\n  presenter?.toggleSelectedFeature(id);\n}\n\nfunction isActive(id: number): boolean {\n  return selectedFeatures.value.includes(id);\n}\n</script>\n\n<template>\n  <div class=\"flex-column registration-form-container\">\n    <div class=\"registration-data-subtitle\">{{ userViewModel?.form.name }}様, 他の機能やサービスにもご興味はありますか？</div>\n\n    <div class=\"feature-grid\">\n      <button\n        v-for=\"f in features\"\n        :key=\"f.id\"\n        class=\"feature-card\"\n        :class=\"{ active: isActive(f.id) }\"\n        @click=\"toggleSelected(f.id)\"\n      >\n        <div class=\"feature-inner\">\n          <component v-if=\"f.icon\" :is=\"f.icon\" :class=\"f.iconClass\" class=\"feature-icon\"/>\n          <div class=\"feature-label\">{{ f.label }}</div>\n        </div>\n\n        <div class=\"feature-tooltip\">\n          <div class=\"font-sm\">{{ f.label }}</div>\n          <div class=\"feature-divider\"></div>\n          <div class=\"tooltip-body\">{{ f.tooltip }}</div>\n          <span class=\"tooltip-arrow\"></span>\n        </div>\n      </button>\n    </div>\n  </div>\n</template>\n\n<style scoped>\n.feature-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 40px 30px;\n  justify-items: center;\n}\n\n.feature-card {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  min-height: 75px;\n  border: 1px solid #0a536e;\n  border-radius: 5px;\n  background: #fff;\n  color: #175874;\n  cursor: pointer;\n  transition: all .15s ease;\n  padding: 12px 16px;\n  text-align: left;\n}\n\n.feature-card.active {\n  background: #0a536e;\n  border-color: #0a536e;\n  color: #fff;\n}\n\n.feature-inner {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.feature-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.feature-tooltip {\n  position: absolute;\n  top: -8px;\n  left: 0;\n  width: 100%;\n  transform: translateY(-100%);\n  opacity: 0;\n  transition: all .16s ease;\n  pointer-events: none;\n  background: #fff;\n  color: #5F6B71;\n  border-radius: 5px;\n  padding: 10px 15px;\n  box-shadow: 0 -1px 3px -1px rgba(0,0,0,.28), 0 6px 18px rgba(0,0,0,.18);\n  z-index: 1;\n}\n\n.feature-card:hover .feature-tooltip {\n  opacity: 1;\n  transform: translateY(-100%) scale(1);\n}\n\n.feature-tooltip::after {\n  /* hide default tooltip */\n  background: none; \n}\n\n.tooltip-body {\n  font-size: 12px;\n}\n\n.tooltip-arrow {\n  position: absolute;\n  bottom: -13px;\n  left: 50%;\n  transform: translateX(-50%) rotate(45deg);\n  width: 26px;\n  height: 26px;\n  background: #fff;\n  z-index: -1;\n}\n\n.feature-card.active .tooltip-title {\n  color: #0a536e;\n}\n\n.feature-icon {\n  width: 30px;\n  height: 30px;\n  fill: currentColor;\n}\n\n.feature-icon-time {\n  width: 40px;\n  height: 40px;\n}\n\n.feature-icon-auto {\n  width: 37px;\n  height: 37px;\n}\n\n.feature-icon-chat {\n  width: 36px;\n  height: 36px;\n}\n\n.feature-divider {\n  border-top: .05rem solid #dadee4;\n  margin: 0.2rem 0 0.4rem 0;\n}\n\n.registration-data-subtitle {\n  margin-top: 55px;\n  font-size: 1rem;\n}\n\n@media (max-width: 450px) {\n  /* First card: show tooltip below instead of above */\n  .feature-card:first-child .feature-tooltip {\n    top: auto;\n    bottom: -8px;\n    transform: translateY(100%);\n  }\n\n  .feature-card:first-child .tooltip-arrow {\n    top: -13px;\n    bottom: auto;\n  }\n\n  .feature-card {\n    width: 250px;\n  }\n\n  .registration-data-subtitle {\n    margin-top: 18px;\n    font-size: 16px;\n  }\n}\n\n@media (max-width: 617px) {\n  .feature-grid {\n    gap: 15px 30px;\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
